module.exports = __webpack_public_path__ + "img/avatar-5.6594d260.png";